/*
 * This code is the intellectual property of Bulb Inc. and other software publishers;
 * it may not be altered, copied or disclosed without prior written approval.
 * Copyright 2016, Bulb Inc.  For more information, please email contact@hellobulb.com.
 */

angular.module('bulbApp.contentEditorModule')
.controller('FrameController', ['$scope', FrameController]);

/**
 *
 */
function FrameController($scope) {
  var that = this;

  this.frameState = 'default';

  this.setFrameState = function(frameState) {
    that.frameState = frameState;
    $scope.$broadcast('frameStateChange', frameState);
  };
}


